import fuzzy from 'fuzzy';
export const isVisibleWhenSearchFiltered = ({
  property,
  searchFilterString = ''
}) => {
  if (!searchFilterString) {
    return true;
  }
  const label = property.label;
  return fuzzy.match(searchFilterString, label);
};